import axios from "axios";
import {LicenseInformationResponse} from "../models/license.models";

export const licenseService = {
    // available for everyone
    validateLicenseStatus: async (signal?: AbortSignal): Promise<void> => {
        return await axios.get('/license/validate', { signal });
    },

    // available for SYSTEM_ADMIN
    fetchLicenseInformation: async (): Promise<LicenseInformationResponse> => {
        const response = await axios.get<LicenseInformationResponse>('/license/information');
        return response.data;
    },

    activateLicenseByKey: async (licenseKey: string): Promise<void> => {
        await axios.put('/license/activate', { licenseKey });
    },

    activateLicenseByFile: async (file: File): Promise<void> => {
        const formData = new FormData();
        formData.append("file", file);

        await axios.put('/license/activate/file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    // verify how should it be handled with 204 response status code
    deactivateLicense: async (): Promise<void> => {
        await axios.put('/license/deactivate');
    }
};